var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"movementStockDetailsChart",staticStyle:{"height":"300px"}}),_c('div',{ref:"legend",staticStyle:{"height":"100px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }